import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const PillsIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8.10393 2.18318C9.6815 0.605607 12.2393 0.605607 13.8168 2.18318C15.3944 3.76075 15.3944 6.3185 13.8168 7.89607L7.89607 13.8168C6.3185 15.3944 3.76075 15.3944 2.18318 13.8168C0.605607 12.2393 0.605607 9.6815 2.18318 8.10393L8.10393 2.18318ZM6.40512 6.00331C7.31209 6.04087 8.2078 6.39845 8.90029 7.07604C9.61228 7.77271 9.97855 8.67957 9.99909 9.59249L12.7562 6.83541C13.7479 5.84363 13.7479 4.23562 12.7562 3.24384C11.7644 2.25205 10.1564 2.25205 9.16459 3.24384L6.40512 6.00331Z"
		></path>
	</svg>
))
